module.exports = __webpack_public_path__ + "img/pic-17.3f586a2a.jpg";